/*
 * Copyright (c) 2024. Dave van Rijn Development
 */

import React, {Context, PropsWithChildren, useEffect} from 'react';
import {ControlVariant} from "./interfaces";
import {convertColor, hexToRgb} from "./colorUtil";

// noinspection JSUnusedGlobalSymbols
export interface ThemeContextShape {
    baseColor: string;
    contrastColor: string;
    onChange: Function;
}

export interface ProviderProps {
    theme: ThemeShape;
}

export interface ThemeShape {
    baseColor: string,
    contrastColor: string,
    controlVariant?: ControlVariant;
    borderColor?: string;
    onChange?: (theme?: ThemeShape) => void;
    noAnimations?: boolean;
}

export const ControlContext: Context<ThemeShape> = React.createContext<ThemeShape>(
    {baseColor: 'black', contrastColor: 'white', controlVariant: ControlVariant.STANDARD});

export default function ThemeContextProvider(props: PropsWithChildren<ProviderProps>) {
    const {theme, children} = props;
    useEffect(() => {
        window.setTimeout(() => {
            const root = document.documentElement;
            const baseRgb = hexToRgb(convertColor(theme.baseColor));
            const contrastRgb = hexToRgb(convertColor(theme.contrastColor));
            root.style.setProperty('--base-color', theme.baseColor);
            root.style.setProperty('--base-color-rgb', `${baseRgb.r}, ${baseRgb.g}, ${baseRgb.b}`);
            root.style.setProperty('--contrast-color', theme.contrastColor);
            root.style.setProperty('--contrast-color-rgb', `${contrastRgb.r}, ${contrastRgb.g}, ${contrastRgb.b}`);
        });
    }, [theme]);

    return (
        <ControlContext.Provider value={theme}>
            {children}
        </ControlContext.Provider>
    )
}